import React from "react";
import { Modal } from "react-bootstrap";
import ModalFormPersona from "./ModalFormPersona";

const ModalPersona = ({ show, handleClose, persona }) => {
  console.log(persona)
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Modificar Persona</Modal.Title>
      </Modal.Header>
      <ModalFormPersona persona={persona} handleClose={handleClose} />
    </Modal>
  );
};

export default ModalPersona;
